import { combineReducers } from "redux";
import drivers from "../features/admin/customer-management/driver/Slice";
import customers from "../features/admin/customer-management/customer/Slice";


const customermanagement = combineReducers({
    drivers: drivers,
    customers: customers
})


export default customermanagement;